import React from 'react';
import { useIntl } from 'react-intl';

import { GameType } from '../../../../types/Game';
import GameCard from '../GameCard/GameCard';

import {
  TXTCLI_Buy_In,
  TXTCLI_N0s,
  TXTCLI_Starting_Blinds,
  TXTCLI_Starting_Chips,
  TXTCLI_Time_Bank
} from './GameCardContent.messages.json';

interface GameCardContentProps {
  tab: string;
  chip: number;
  highBet?: number;
  lowBet?: number;
  timeBank: number;
  buyIn: string;
  isPlayMoney: boolean;
  isSmallScreen: boolean;
}

const GameCardContent: React.FC<GameCardContentProps> = ({
  tab,
  chip,
  highBet,
  lowBet,
  timeBank,
  buyIn,
  isPlayMoney,
  isSmallScreen
}) => {
  const { formatMessage } = useIntl();
  const isHoldemMax = tab === GameType.HoldemMax;

  return (
    <>
      {isHoldemMax && isSmallScreen && (
        <GameCard
          className={isPlayMoney ? 'BuyInPlay' : 'BuyInReal'}
          label={formatMessage(TXTCLI_Buy_In)}
          value={buyIn}
          dataTestId="prize-distribution-game-card-buy-in"
        />
      )}
      {chip && (
        <GameCard
          className="Chip"
          label={formatMessage(TXTCLI_Starting_Chips)}
          value={chip || '-'}
          dataTestId="prize-distribution-game-card-chip"
        />
      )}
      {isHoldemMax && (
        <GameCard
          className="StartingBlinds"
          label={formatMessage(TXTCLI_Starting_Blinds)}
          value={highBet && lowBet ? `${lowBet}/${highBet}` : '-/-'}
          dataTestId="prize-distribution-game-card-starting-blinds"
        />
      )}
      <GameCard
        className="TimeBank"
        label={formatMessage(TXTCLI_Time_Bank)}
        value={timeBank ? formatMessage(TXTCLI_N0s, { 0: timeBank.toString() }) : '-'}
        dataTestId="prize-distribution-game-card-time-bank"
      />
    </>
  );
};

export default GameCardContent;
